import { render } from "./WorkshopPage.vue?vue&type=template&id=54023ecc&scoped=true"
import script from "./WorkshopPage.vue?vue&type=script&lang=js"
export * from "./WorkshopPage.vue?vue&type=script&lang=js"

import "./WorkshopPage.vue?vue&type=style&index=0&id=54023ecc&lang=css"
import "./WorkshopPage.vue?vue&type=style&index=1&id=54023ecc&scoped=true&lang=css"

import exportComponent from "F:\\MyCode\\ZSTek.SpecialEquipment\\ZSTek.SE.Screen.Web.Backstage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54023ecc"]])

export default __exports__